import { nanoid } from "nanoid";
export const urlAddParam = (url, param) => url + (url.split("?")[1] ? "&" : "?") + param;
export const urlUnique = (url) => urlAddParam(url, `at=${nanoid(30)}`);
export const urlTop = (url) => {
    const latestChar = url.charAt(url.length - 1);
    if (latestChar === "/") {
        url = url.slice(0, -1);
    }
    const arr = url.split("/");
    arr.pop();
    return arr.join("/") || "/";
};
/**
 * TODO: remove this functions ASAP, it is urlTop now
 */
export const urlBack = (url, steps = 1) => {
    const latestChar = url.charAt(url.length);
    if (latestChar === "/") {
        url = url.slice(0, -1);
    }
    const arr = url.split("/");
    [...Array(steps).keys()].forEach(() => {
        arr.pop();
    });
    return arr.join("/") || "/";
};
//# sourceMappingURL=url.js.map